import { useSearchParams } from 'react-router-dom';

import { Box, Container, Typography } from '@mui/material';

export const ServiceUnavailablePage = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') || '503';
  const message = searchParams.get('message') || 'Service temporarily unavailable';

  return (
    <Container>
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h1" component="h1" gutterBottom>
          {status}
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          Service Error
        </Typography>
        <Typography color="text.secondary" paragraph sx={{ textAlign: 'center', maxWidth: '500px' }}>
          {message}
        </Typography>
      </Box>
    </Container>
  );
};
